import Button from '@material-ui/core/Button';
import Card from '../../../../components/Card/CardTS';
import CardBody from '../../../../components/Card/CardBody.js';
import CardHeader from '../../../../components/Card/CardHeader.js';
import CardIcon from '../../../../components/Card/CardIcon.js';
import React from 'react';
import regularFormsStyle from '../../../../assets/jss/material-dashboard-pro-react/views/regularFormsStyleTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { deleteSystem } from '../../../stores/actions/installerActions';
import { connect } from 'react-redux';
import Person from '@material-ui/icons/Person';
import { Account, ISystem } from '../../../helpers/interfaces';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../../helpers/CustomStyles';
import RemoveSystemConfirmationCard from '../../../components/RemoveSystemConfirmationCard/RemoveSystemConfirmationCard';

import '../InstallerPanel.css';

interface IDeleteSystemProps {
    classes: ClassNameMap;
    mobileView: boolean;
    deleteSystem: (systemID) => void;
    systems: ISystem[];
}

const DeleteSystem = ({
    mobileView,
    deleteSystem,
    systems,
    ...props
}: IDeleteSystemProps) => {
    const { classes } = props;
	const [pickedSystem, setPickedSystem] = useState<number|null|undefined>(null);
    const systemIds = systems.map(el => el.ID);
    const systemNamesByIds = Object.fromEntries(systems.map(x => [x.ID, x.name]));  
    const [confirmationWindow, setConfirmationWindow] = useState<any>(null);
    const handleDeleteSystem = (): void => {
        if (pickedSystem) {
            showRemoveSystemConfirmation();
        }
    }
    const deleteButton = (): JSX.Element => {
        return (
            <Button
                size='medium'
                style={{ marginTop: '25px', transition: 'color 0.3s' }}
                disabled={!pickedSystem}
                onClick={(e) => { handleDeleteSystem() }}
            >
                Delete
            </Button>
        );
    };
	const hideRemoveSystemConfirmation = () => {
		setConfirmationWindow(null);
	};

	const showRemoveSystemConfirmation = (): void => {
        const system =  _.filter(systems, { ID: pickedSystem })[0];
		setConfirmationWindow(
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={hideRemoveSystemConfirmation}
				onCancel={hideRemoveSystemConfirmation}
				key='remove-system-confirmation-alert'
			>
				<RemoveSystemConfirmationCard system={system} hideRemoveSystemConfirmation={hideRemoveSystemConfirmation} />
			</SweetAlert>
		);
	};

    if (systems.length < 1) {
        return (
            <Card>
                <CardHeader color='info' icon>
                    <CardIcon color='info'>
                        <Person />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle}>
                        Delete System
                    </h4>
                </CardHeader>
                <CardBody>Please add a system first.</CardBody>
            </Card>
        );
    }

    return (
        <>
        {confirmationWindow}
        <Card className='inviteUserForm'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                    <Person />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Delete System</h4>
            </CardHeader>
            <CardBody>
                <FormControl fullWidth className={classes.selectFormControl} onSubmit={(e) => e.preventDefault()}>
                    <div style={{ width: '100%' }}>
                        <Autocomplete
                            options={systemIds}
                            getOptionLabel={(id) => systemNamesByIds[id]}
                            id='system-name'
                            value={pickedSystem}
                            onChange={(e, newVal) => setPickedSystem(newVal)}
                            renderInput={(systemIds) => <TextField {...systemIds} label='Systems' margin='normal' />}
                            style={{ width: '100%' }}
                        />
                    </div>
                </FormControl>
                {deleteButton()}
            </CardBody>
        </Card>
        </>
    );
};

const mapStateToProps = (state) => ({
    systems: state.installer.systemsForInstallerPanel || [],
    mobileView: state.dashboard.mobileView,
});
const actions = {
    deleteSystem
};

const DeleteSystemWithStyles = regularFormsStyle(DeleteSystem);
export default connect(mapStateToProps, actions)(DeleteSystemWithStyles);
